import * as React from "react";
const Sunset = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="#091E42"
      fillRule="evenodd"
      d="M6 1C3.24 1 1 3.24 1 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5ZM2 6c0-2.21 1.79-4 4-4 .925 0 1.775.315 2.45.845L2.845 8.45A3.951 3.951 0 0 1 2 6Zm1.55 3.155C4.225 9.685 5.075 10 6 10c2.21 0 4-1.79 4-4 0-.925-.315-1.775-.845-2.45L3.55 9.155Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Sunset;
